import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ChevronRight } from 'lucide-react';

export const AboutPreview = ({ t, aboutImage, aboutFit, aboutPosition }) => (
  <section className="py-10 md:py-14 lg:py-16" data-testid="about-preview-section">
    <div className="container-apex">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div className="order-2 lg:order-1 relative">
          {aboutImage && (
            <img
              src={aboutImage}
              alt="Equipe Apex Medical Hub"
              className="rounded-2xl shadow-xl w-full"
              style={{ objectFit: aboutFit, objectPosition: aboutPosition }}
              loading="lazy"
            />
          )}
        </div>
        <div className="order-1 lg:order-2">
          <p className="text-[#007f73] font-medium mb-3 text-sm uppercase tracking-wider">
            {t('about-title', 'Sobre a Apex Medical Hub')}
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            Uma equipe dedicada ao sucesso do seu negócio médico
          </h2>
          <p className="text-slate-600 text-lg mb-6 leading-relaxed">
            {t('about-description', 'A Apex Medical Hub nasceu da percepção de que médicos e clínicas precisavam de muito mais do que uma contabilidade tradicional. Precisavam de um parceiro estratégico que entendesse as particularidades do setor de saúde.')}
          </p>
          <p className="text-slate-600 mb-8 leading-relaxed">
            Combinamos expertise tributária, inteligência financeira e visão gerencial para entregar 
            uma estrutura de backoffice completa que liberta médicos da burocracia e permite foco 
            total nos pacientes.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button asChild className="btn-primary rounded-md px-6">
              <Link to="/sobre">
                Conheça nossa história
                <ChevronRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button asChild variant="outline" className="btn-secondary rounded-md px-6">
              <Link to="/contato">Entre em contato</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  </section>
);
